// Shared by mwoverview/mwlistdeals click handlers so a no-access user is blocked
// identically to a logged-out user, just with the modal chosen based on why they're blocked.
export const guardMarketsAccess = (e, { isLogged, hasMarketsAccess, setSignUpModalIsOpen, setUserRolesModalIsOpen }) => {
  if (!isLogged) {
    e.preventDefault()
    e.stopPropagation()
    setSignUpModalIsOpen(true)
    return true
  }

  if (!hasMarketsAccess) {
    e.preventDefault()
    e.stopPropagation()
    setUserRolesModalIsOpen(true)
    return true
  }

  return false
}
